import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";

import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@tCentro/Overrides/Components/AddressInfoDisplay";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsBillingAddressStyles {
    headerText?: TypographyPresentationProps;
    titleText?: TypographyProps;
    addressDisplay?: AddressInfoDisplayStyles;
    wrapper?: InjectableCss;
}

export const billingAddressStyles: OrderDetailsBillingAddressStyles = {
    headerText: {
        variant: "h5",
        css: css`
            display: none;
            @media print {
                font-size: 12px;
                display: none;
            }
            margin-bottom: 5px;
            font-size: ${TYPOGRAPHY.size.large} !important;
        `,
    },
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
            font-size: 16px;
            padding-top: 10px;
        `,
    },
};

const styles = billingAddressStyles;

const OrderDetailsBillingAddress: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="orderDetailBillingInformation">
            <Typography as="h2" {...styles.headerText}>
                {translate("Billing Information")}
            </Typography>
            <Typography {...styles.titleText}>{translate("Billing Address")}</Typography>
            <AddressInfoDisplay
                companyName={order.btCompanyName}
                customerNumber={order.customerNumber}
                address1={order.btAddress1}
                address2={order.btAddress2}
                address3={order.btAddress3}
                address4={order.btAddress4}
                city={order.billToCity}
                state={order.billToState}
                postalCode={order.billToPostalCode}
                country={order.btCountry}
                extendedStyles={styles.addressDisplay}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsBillingAddress,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
